/* AZ & CO. — two things the page was paying for and not using.

   Classic script, deferred. Nothing here is required for the page to be
   correct: delete the file and the two lines that load it in
   layout/theme.liquid and everything still works, only slower.

   ------------------------------------------------------------------ 1
   The hero images past the second.

   The rotation hides its slides with opacity and a mask rather than with
   display, so every one of them is inside the viewport from the first
   frame and loading="lazy" declines to help. All eight downloaded at once,
   at 1000w or 1400w, against the LCP image on the same connection.

   spot-slide.liquid now holds the URLs on data attributes for slides three
   and up. This puts them back: the one after the current slide just before
   the rotation reaches it, the remainder on idle after load.

   ------------------------------------------------------------------ 2
   Nothing at all when the rotation is not running.

   Under prefers-reduced-motion theme.js leaves the hero on slide one
   forever. The other bottles are then never seen, so they are never
   fetched — which is the same amount of respect for a data plan as it is
   for a vestibular system. */

(function () {
  'use strict';

  var host = document.getElementById('spotlight');
  if (!host) return;

  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hydrate (img) {
    if (!img || !img.getAttribute('data-src')) return;
    var set = img.getAttribute('data-srcset');
    var sizes = img.getAttribute('data-sizes');
    if (sizes) img.setAttribute('sizes', sizes);
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');
    img.classList.remove('spot-wait');
  }

  /* The slide after the one showing, so it has arrived before it is asked
     for. theme.js re-orders the slides on load when the hero is not fixed,
     so this reads the running order out of the DOM rather than an index. */
  function ahead () {
    var on = host.querySelector('.spot[data-on]');
    var next = on && on.nextElementSibling;
    if (!next) next = host.querySelector('.spot');
    if (next) hydrate(next.querySelector('img[data-src]'));
  }

  function rest () {
    var waiting = host.querySelectorAll('img[data-src]');
    for (var i = 0; i < waiting.length; i++) hydrate(waiting[i]);
  }

  if (still) return;

  if (window.MutationObserver) {
    new MutationObserver(ahead).observe(host, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-on']
    });
  }

  function begin () {
    ahead();
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(rest, { timeout: 5000 });
  }

  if (document.readyState === 'complete') begin();
  else addEventListener('load', begin);
}());
